import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const DevRoomsStore = GenericCollectionFactory("DEV_ROOMS", "uid");